<template>
  <thead>
    <tr>
      <th
        class="w-1/12 px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
      >
        id
      </th>
      <th
        class="w-3/12 px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
      >
        name
      </th>
      <th
        class="w-7/12 px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
      >
        description
      </th>
      <th
        class="w-1/12 px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-50 text-blueGray-500 border-blueGray-100"
      ></th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "TableHead"
};
</script>
